import type { PlaceFeature } from "~/lib/api";
import type { AccentScheme } from "~/lib/placeAccents";
import { cn } from "~/lib/utils";
import { Icon } from "~/components/ui/icons/icon";
import { PlaceStats } from "~/components/place/PlaceStats";

interface CompactListItemProps {
  place: PlaceFeature;
  isSelected: boolean;
  accent: AccentScheme;
  className?: string;
}

export function CompactListItem({ place, isSelected, accent, className }: CompactListItemProps) {
  const { properties } = place;
  const { images, name, description } = properties;
  const thumbnail = images[0]?.thumb;

  return (
    <div
      className={cn(
        "group w-full text-left px-4 py-3 rounded-xl transition-all duration-200",
        "flex items-center gap-4 border",
        {
          [accent.bg]: isSelected,
          [accent.border]: isSelected,
          "border-border hover:bg-muted/50": !isSelected,
        },
        className,
      )}
    >
      {thumbnail ? (
        <div className="shrink-0 size-10 rounded-lg overflow-hidden bg-muted">
          <img src={thumbnail} alt="" aria-hidden loading="lazy" className="size-full object-cover" />
        </div>
      ) : (
        <div className={cn("shrink-0 size-2 rounded-full", accent.solid)} />
      )}

      <div className="flex-1 min-w-0">
        <h4 className="font-medium text-foreground truncate">{name}</h4>
        <PlaceStats
          properties={properties}
          compact
          className="mt-1 text-muted-foreground"
          fallback={description ? <p className="text-sm text-secondary truncate">{description}</p> : undefined}
        />
      </div>

      <Icon
        i="chevron-right"
        className="shrink-0 size-4 text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity"
      />
    </div>
  );
}
